import React from 'react'
import launchIcon from '@/assets/images/svg/stepper/launchplan-icon.svg';
import growthIcon from '@/assets/images/svg/stepper/growthplan-icon.svg';
import scaleIcon from '@/assets/images/svg/stepper/scaleplan-icon.svg';

const PlanCard = ({title, description, price, originalPrice, image, active,
  onClick }) => {
  return (
    <div className={`plan-card ${active ? "active" : ""}`}
 onClick={onClick}>
        <div className='plan-left'>
             <h3 className='plan-title'>{title}</h3>
             <p className='plan-decs'>{description}</p>
             <div className='price-wrap'>
              <span className='plan-price'>{`$${originalPrice}`}</span>
             <span className='current-price'>{`$${price}`}</span>
             </div>
        </div>
        <div className='plan-right'>
            <div className='check-icon'>
              <i className="fa-solid fa-circle-check me-1"></i>
            </div>
            <div className='plan-img'>
               {image && <img src={image == 'launch' ? launchIcon : (image == 'growth') ? growthIcon : scaleIcon} alt={title} />}
            </div>
        </div>
      
    </div>
  )
}

export default PlanCard
